module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.de2dd933.otf";